import { render } from "./NewContractors.vue?vue&type=template&id=7815732d&scoped=true"
import script from "./NewContractors.vue?vue&type=script&lang=js"
export * from "./NewContractors.vue?vue&type=script&lang=js"

import "./NewContractors.vue?vue&type=style&index=0&id=7815732d&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7815732d"]])

export default __exports__